import React from "react";

import { useIntl } from "react-intl";

import HostSelector from "src/organization/pages/project/environment/metrics/components/HostSelector";

type InstanceSelectorProps = {
  instances: Array<string>;
  selected: Array<string>;
  onChange: (instances: Array<string>) => void;
};
const InstanceSelector = (props: InstanceSelectorProps) => {
  const intl = useIntl();
  const { instances, selected, onChange } = props;
  const instanceCount = instances?.filter(i => i !== "average").length;
  return instanceCount > 1 ? (
    <HostSelector
      hosts={instances}
      selected={selected}
      onChange={onChange}
      prefixHost={false}
      filterTitleId={`${instanceCount} ${intl.formatMessage({
        id: "instances"
      })}`}
    />
  ) : null;
};

export default InstanceSelector;
